module.exports = __webpack_public_path__ + "static/img/jifenBg.7960418.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/jifenBg.png
// module id = qyVM
// module chunks = 36